import elementLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  floorplanEvaluation: {
    entry: "建筑户型评价",
    aiResultOnly: "评价使用当前项目最新一次成功的 AI 建筑设计结果。前端修改无论是否保存，均不参与评价。",
    running: "正在进行建筑户型评价／加载评价结果",
    previousVersion: "此评价对应较早的 AI 建筑设计结果，或暂时无法确认结果版本一致性。",
    total: "综合得分",
    normalized: "百分制折算分",
    objective: "客观得分",
    subjective: "主观得分",
    details: "评价详情",
    empty: "暂无已完成的评价",
    refresh: "刷新结果",
    start: "开始评价",
    failed: "建筑户型评价失败，请重试",
    OBJ_01: "房间类型与数量正确性",
    OBJ_03: "MyBox 经验尺寸符合度",
    OBJ_06: "相邻楼层楼梯对齐",
    OBJ_07: "主要房间连续外墙接触潜力",
    functional_zoning: "功能分区",
    circulation_organization: "交通组织",
    privacy: "私密性",
    spatial_comfort: "空间舒适性"
  },
  common: {
    appName: 'MH House',
    home: '首页',
    login: '登录',
    workspace: '工作台',
    logout: '退出登录',
    notFound: '页面不存在',
    backHome: '返回首页',
    cancel: '取消',
    confirm: '确认',
    apply: '应用',
    close: '关闭',
    all: '全部',
    user: '用户',
    updated: '更新',
    project: '项目'
  },
  nav: {
    wallet: '钱包',
    changePassword: '修改密码',
    titles: {
      projectsStructure: '结构项目',
      houseDesign: '项目详情',
      architecturePlan: '建筑平面设计',
      structureDesign: '结构设计',
      structureCalculation: '结构计算',
      designReport: '设计结果报告'
    }
  },
  home: {
    title: 'MH House WebUI',
    subtitle: '一个为新项目准备的干净前端骨架。',
    openWorkspace: '进入工作台'
  },
  login: {
    title: '登录',
    username: '用户名',
    password: '密码',
    submit: '登录',
    placeholder: '登录接口占位，后端协议确定后替换。'
  },
  workspace: {
    title: '工作台',
    subtitle: '受保护路由占位页面。'
  },
  projects: {
    searchPlaceholder: '请输入项目标题',
    empty: '暂无项目',
    fetchFailed: '获取项目列表失败',
    missingIdempotencyKey: '项目缺少幂等键，无法进入详情',
    projectFallback: '项目 {id}',
    newProject: '新建项目',
    createDialogTitle: '新建项目',
    createDialogPlaceholder: '请输入项目名称',
    createNameRequired: '请输入项目名称',
    createFailed: '创建项目失败',
    createConfirm: '创建',
    manageProjects: '管理项目',
    exitManage: '退出管理',
    deleteSelected: '删除（{count}）',
    deleteConfirmTitle: '删除项目',
    deleteConfirmMessage: '确定删除选中的 {count} 个项目吗？此操作不可撤销。',
    deleteConfirmButton: '删除',
    deleteSuccess: '已删除 {count} 个项目',
    deleteFailed: '删除项目失败'
  },
  houseDesign: {
    backToProjects: '返回项目',
    pageTitle: '项目详情',
    pageTitleWithKey: '项目详情 - {key}',
    idempotencyKey: '项目幂等键：{key}',
    missingKey: '缺少项目幂等键，请从项目列表重新进入。',
    progressTitle: '项目流程进展',
    enterStepTitle: '进入步骤',
    enterStep: '进入{step}',
    stepStatus: {
      completed: '已完成',
      current: '当前步骤',
      pending: '待进入'
    },
    steps: {
      architecturePlan: '建筑平面设计',
      structureDesign: '结构设计',
      structureCalculation: '结构计算',
      designReport: '设计结果报告'
    }
  },
  constraints: {
    back: '返回项目',
    title: '请告诉我们建筑的预算与間口',
    budget: {
      title: '预算'
    },
    frontage: {
      title: '間口',
      meters: '约 {meters} m'
    },
    recommendFailed: '暂时无法取得商品推荐，请稍后重试',
    next: '下一步'
  },
  structureDesign: {
    generating: '生成中...',
    back: '返回',
    title: '一户建AI设计',
    subtitle: '设计编辑器 · {name}',
    undo: '撤销',
    redo: '重做',
    save: '保存',
    saveToStorage: '保存',
    exportToFile: '导出到文件',
    exportProjectJson: '导出项目 JSON',
    exportCadJson: '导出 CAD JSON',
    cadExport: {
      warningTitle: 'CAD 交付校验警告',
      warningMessage: 'CAD JSON 含有校验警告。仍可下载，但交付数据未完全验证。',
      continue: '仍然导出',
      fatal: '平面图包含无效 CAD 几何，无法导出。',
      failed: 'CAD JSON 导出失败，请重试。',
      exported: 'CAD JSON 已导出：{fileName}',
      annotationsSaveFailed: '尺寸标注已包含在导出文件中，但无法保存到当前项目。',
      issueCategories: {
        geometry: '几何校验警告（{code}）',
        annotations: '标注校验警告（{code}）',
        structure: 'AI 结构校验警告（{code}）'
      }
    },
    exportedToFile: '已导出到文件：{fileName}',
    exportFailed: '导出失败，请重试',
    load: '加载',
    project: '项目',
    tools: '工具',
    select: '选择',
    sampleRoom: '示例房间',
    catalog: '目录',
    searchCatalog: '搜索目录',
    designAssetRoomFilter: '房间',
    designAssetStyleFilter: '风格',
    designAssetRooms: {
      kitchen: '厨房',
      bathroom: '浴室',
      washroom: '洗面室',
      outdoor: '屋外',
      'living-dining': '客厅餐厅',
      'master-bedroom': '主卧',
      'kids-room': '儿童房'
    },
    designAssetStyles: {
      'white-model': '白模',
      natural: '自然',
      'simple-modern': '简约现代',
      japandi: '日式北欧',
      vintage: '复古'
    },
    catalogFilterEmpty: '未找到匹配的素材',
    catalogFilterClear: '清除筛选',
    catalogFilterLoading: '正在筛选…',
    catalogFilterBack: '返回分类浏览',
    catalogFilterToggle: '展开或收起筛选',
    properties: '属性',
    settings: '设置',
    projectConfiguration: '项目配置',
    aiDesign: 'AI 设计参数',
    generate: '生成设计',
    view2d: '2D 视图',
    view3d: '3D 视图',
    switchTo3d: '点击将主画面切换为 3D',
    switchTo2d: '点击将主画面切换为 2D',
    zoomIn: '放大',
    zoomOut: '缩小',
    fitView: '适应画布',
    openCatalog: '打开目录',
    export: '导出',
    exportChooseFormat: '选择导出格式',
    import: '导入',
    developing: '开发中',
    catalogTitle: '元素目录',
    catalogHint: '选择一个元素，然后在二维画布中点击完成放置',
    catalogAvailable: '共 {count} 个可用元素',
    catalogEmptyTitle: '没有找到匹配的元素',
    catalogEmptyHint: '尝试更换分类或搜索关键词',
    catalogFooter: '目录 / {category}',
    clearSearch: '清除搜索',
    inspectorDeveloping: '该部分功能正在开发中',
    selectionSummary: '已选择 {count} 个元素',
    emptyState: '选择一个元素或从目录选择构件，然后在画布上编辑。',
    editorToolbar: {
      label: '编辑器命令',
      file: '文件',
      clear: '清空',
      ai: 'AI',
      pdf: 'PDF 导出',
      html: 'HTML 导出',
      share: '分享',
      clearConfirmTitle: '清空方案',
      clearConfirmMessage: '此操作将清空当前方案内容，是否继续？',
      placeholderNotice: '该功能将在后续模块接入，当前为占位入口。'
    },
    clearScene: {
      success: '方案已清空',
      failed: '清空方案失败，请重试'
    },
    // 图纸底图：从图纸导入时铺在几何下面的原图。刻意不叫「底图」——
    // 那个词已经被 aiStructure.overlay 的「建筑底图」占了。
    drawingUnderlay: {
      title: '底图',
      show: '显示底图',
      hide: '隐藏底图',
      opacity: '底图透明度',
      elementOpacity: '构件透明度'
    },
    viewSettings: {
      title: '3D 显示设置',
      daylight: '日照',
      daylightSlider: '日照时间',
      presets: {
        morning: '早晨',
        midday: '中午',
        evening: '傍晚',
        night: '夜晚'
      },
      ceilingHeight: '天花板高度',
      sectionCut: '剖切',
      sectionCutHint: '不显示剖切高度以上的部分。'
    },
    editorToolGroups: {
      draw: '画房间/墙体',
      openings: '放门窗',
      structure: '加结构',
      furnishings: '家具软装'
    },
    editorToolPanels: {
      drawHouse: '户型',
      layout: '家具与材质'
    },
    camera: {
      tool: "相机",
      renderTool: "渲染",
      renderTitle: "渲染",
      renderRecaptureHint: "按相机当前的位置重新截图",
      previewTitle: "相机 {index} · 3D 视图",
      openComposition: "调整构图",
      previewHint: "点击调整构图",
      placingHint: "请在平面图上点击以放置相机",
      addOverhead: "3D 俯视",
      addOverheadHint: "添加从上方俯视建筑的相机",
      overheadBadge: "俯视",
      overheadHint: "从上方俯视所选楼层的相机。",
      compositionFromPreview: "构图在右上角的 3D 视图中调整。",
      place: "放置相机",
      panelTitle: "相机",
      empty: "没有相机。请在平面图上放置",
      limitReached: "最多 {max} 台相机",
      item: "相机 {index}",
      position: "位置",
      elevation: "高度",
      yaw: "朝向",
      pitch: "俯仰",
      fov: "视野",
      remove: "删除相机",
      enterComposition: "进入 3D 构图",
      clampedTo: "已钳制到 {value}",
      readonlyHint: "项目为只读，相机不可编辑",
      lockedWhileRendering: "出图进行中，相机不可编辑",
      compositionTitle: "3D 构图 · 相机 {index}",
      compositionDone: "完成",
      compositionCancel: "取消",
      compositionHint: "拖动旋转视角、滚轮缩放；框内即最终出图范围",
      compositionAspect: "16:9（与出图比例一致）",
      compositionDegraded: "窗口太小，构图框已按比例缩放显示",
      batchEntry: "批量出图",
      batchViewResults: "查看出图结果",
      batchFromCameras: "使用 {count} 台相机出图",
      batchTitle: "批量出图",
      batchNew: "新建出图",
      batchHistoryEmpty: "暂无出图记录，请在右侧相机面板发起出图",
      batchFailedUnknown: "生成失败，未返回具体原因，请重试或稍后再试",
      batchFailedTimeout: "生成超时，请重试",
      batchCaptureBusy: "上一次截图尚未结束，请稍候再试",
      batchPreviousResult: "上一轮结果",
      batchCameraNoResult: "尚无出图结果",
      batchCameraRemoved: "相机已删除，出图结果保留",
      batchRowSatisfied: "已满足，本轮未生成",
      batchStepConfig: "配置",
      batchStepCapture: "确认截图",
      batchCaptureConfirm: "请确认各相机取景，如需调整可重新截图",
      batchCaptureZoom: "点击查看大图",
      batchRecapture: "重新截图",
      batchCaptureNext: "使用 {count} 张，继续配置",
      batchCaptureAllFailed: "截图全部失败，请调整相机位置后重试",
      batchStepRender: "渲染",
      batchTarget: "每台目标张数",
      batchStyle: "风格",
      batchStylized: "画风",
      batchResolution: "分辨率",
      batchPromptPlaceholder: "补充要求（选填）",
      batchStartFailed: "出图启动失败，请稍后重试",
      batchGenerate: "生成缺口 {count} 张",
      batchAllSatisfied: "全部机位已满足，无需生成",
      batchNoCameras: "请先在平面图上放置相机",
      batchAdopt: "采用",
      batchAdopted: "已采用 {n}/{k}",
      batchSatisfied: "已满足 {k}/{k}",
      batchStale: "相机 {index} 的机位已变更，之前采用的 {n} 张图不再计入",
      batchCapturing: "正在截图 {i}/{n}",
      batchSubmitting: "正在提交 {i}/{n}，请勿离开页面",
      batchQueued: "排队中",
      batchPendingCapture: "待截图",
      batchCaptured: "已截图，待提交",
      batchRunning: "生成中",
      batchDone: "已完成",
      batchFailed: "失败",
      batchRetry: "重试",
      batchSkip: "跳过",
      batchUnsupported: "后端暂不支持一次生成 {n} 张，请先升级 api 服务后再试",
      batchInvalid: "已失效",
      batchClose: "关闭",
    },
    editorToolSections: {
      stair: '楼梯',
      accessory: '小物件',
      material: '材质',
      furniture: '家具',
      lighting: '照明',
      builtin: '木作',
      appliance: '家电',
      equipment: '设备'
    },
    editorToolCategories: {
      stairStairs: '楼梯',
      accessoryClocks: '时钟',
      accessoryMirrors: '镜子',
      accessoryCushions: '靠垫',
      accessoryArt: '装饰画・墙饰',
      accessoryPlants: '绿植',
      accessoryOther: '其他',
      furnitureDiningTables: '餐桌',
      furnitureDesks: '书桌',
      furnitureDoubleBeds: '双人床',
      furnitureSingleBeds: '单人床',
      furnitureRugs: '地毯',
      furnitureOther: '其他',
      lightingPendant: '吊灯',
      lightingDown: '筒灯',
      lightingSpot: '射灯',
      lightingStand: '落地灯・台灯',
      lightingBracket: '壁灯',
      lightingOther: '其他',
      builtinCounter: '台面',
      builtinShelf: '搁架',
      builtinPillowShelf: '床头搁板',
      builtinStorage: '收纳',
      builtinEntranceStorage: '玄关收纳',
      builtinOther: '其他',
      applianceRefrigerator: '冰箱',
      applianceTv: '电视',
      applianceWasher: '洗衣机',
      applianceDryer: '烘干机',
      applianceMicrowave: '微波炉',
      applianceVacuum: '吸尘器',
      applianceOther: '其他',
      equipmentKitchen: '厨房',
      equipmentCupboard: '橱柜',
      equipmentToilet: '马桶',
      equipmentWashbasin: '洗面台',
      equipmentBathtub: '浴缸',
      equipmentWasher: '洗衣机',
      equipmentWaterHeater: '热水器',
      equipmentAirConditioner: '空调',
      equipmentSwitch: '开关',
      equipmentOther: '其他',
      furnitureKitchen: '厨房',
      furnitureToilet: '厕所',
      furnitureBathroom: '浴室',
      furnitureWashbasins: '洗面台',
      furnitureAppliances: '家电',
      furnitureAirConditioning: '空调设备',
      furnitureWaterHeating: '热水设备',
      walls: '墙体',
      doorWindow: '门窗',
      holes: '洞口',
      structure: '结构',
      stairs: '楼梯',
      furniture: '家具',
      kitchenBath: '厨卫',
      furnitureSofa: '沙发',
      furnitureTables: '桌/书桌',
      furnitureChairs: '椅/凳',
      furnitureTableSets: '桌椅组合',
      furnitureBeds: '床',
      furnitureCabinets: '收纳',
      furnitureStorage: '收纳',
      furnitureLighting: '照明',
      furnitureCushions: '抱枕',
      furnitureClocks: '时钟',
      furnitureArtDecor: '艺术装饰',
      furnitureMirrors: '镜子',
      materialWallpaper: '墙材',
      materialFlooring: '地板',
      other: '其他',
      kitchenBathCabinet: '橱柜',
      kitchenBathKitchen: '厨房',
      kitchenBathEquipment: '设备',
      kitchenBathVanity: '浴室柜',
      kitchenBathSanitary: '卫浴'
    },
    editorToolRequired: {
      wall: '墙体',
      area: '房间区域',
      door: '门',
      doorDouble: '双开门',
      slidingDoor: '推拉门',
      window: '窗',
      sashWindow: '推拉窗',
      gate: '大门',
      floorOpening: '楼板洞口',
      column: '柱子',
      columnSquare: '方柱',
      beam: '梁',
      simpleStair: '简易楼梯',
      sofa: '沙发',
      tables: '桌/茶几',
      chairs: '凳/椅',
      tableSets: '桌椅组合',
      beds: '床/组合床',
      cabinets: '柜/架',
      kitchenCabinet: '橱柜',
      kitchen: '厨房',
      equipment: '设备',
      bathroomVanity: '浴室柜',
      sanitary: '卫浴'
    },
    editorToolUnavailable: '暂未提供',
    editorProperty: {
      emptyTitle: '未选中对象',
      emptyHint: '选择墙、门窗、家具等后可在此编辑。'
    },
    wallSurfaceMaterial: {
      title: '墙面材质',
      currentSide: '墙面材质 · {side}',
      sideA: 'A · 沿墙方向左侧',
      sideB: 'B · 沿墙方向右侧',
      heading: '墙面材质',
      sideAShort: 'A面',
      sideBShort: 'B面',
      sideGroup: '墙面侧别',
      texture: '纹理',
      color: '颜色',
      source: '来源',
      clearSide: '清除本侧覆盖',
      sources: { surface: '本侧覆盖', legacy: '墙体属性', theme: '主题默认值' },
      textures: { bricks: '砖墙', painted: '涂料墙' }
    },
    property: {
      clampedTo: '数值已调整至范围 {min}-{max}，实际应用值为 {actual}',
      fittedToWall: '为适配墙体，已调整为 {actual}'
    },
    editorBottom: {
      otherFloorOpacity: '其他楼层透明度',
      showOtherFloors: '显示其他楼层',
      hideOtherFloors: '隐藏其他楼层',
      expand3d: '放大',
      previewInCanvas: '3D 预览已移至中央画布',
      statistics: '数据统计'
    },
    aiRoomDesign: {
      title: 'AI 房间设计',
      open: 'AI 房间',
      selectedProduct: '已选商品',
      noProduct: '尚未选择商品',
      selectProduct: '选择商品',
      browseProducts: '浏览商品',
      layerCount: '层数',
      livingRoom: '起居室',
      diningRoom: '餐厅',
      masterRoom: '主卧',
      secondRoom: '次卧/书房',
      kitchen: '厨房',
      bathroom: '卫生间',
      storage: '储藏室',
      staircase: '楼梯',
      notice1: 'AI 将参考此需求，最终房间构成由算法决定',
      notice2: '生成的布局将对齐 455mm 模块网格，并会移除现有门窗',
      elapsed: '已耗时',
      submit: '生成房间布局',
      needAtLeastOneRoom: '至少需要一个房间',
      successTitle: '房间布局生成成功'
    },
    aiWindowDesign: {
      title: 'AI 门窗设计',
      open: 'AI 门窗',
      roomCount: '当前房间数',
      notice: '将为所有墙体生成门窗，现有门窗将被替换',
      elapsed: '已耗时',
      submit: '生成门窗',
      successTitle: '门窗生成成功',
      successMessage: '已生成 {doorCount} 个门、{windowCount} 个窗'
    },
    aiCandidatePreview: {
      previewTitle: 'AI 方案预览',
      currentScene: '当前方案',
      candidateScene: 'AI 候选方案',
      previewHint: '请对比两个方案，确认后应用',
      floorLabel: '楼层',
      outlineDiffsTitle: '轮廓差异明细',
      layer: '楼层',
      beforeSize: '原尺寸',
      afterSize: 'AI 尺寸',
      sizeChange: '尺寸变化',
      areaCoverage: '覆盖面积',
      areaChange: '面积变化',
      applyRoomLabel: '应用 AI 房间设计',
      applyWindowLabel: '应用 AI 门窗设计'
    },
    reportCapture: {
      title: '报告图片确认',
      stepFloors: '2D 户型',
      stepViews: '3D 视角',
      floorsHint: '请确认各楼层的户型图，系统已按内容自动截图。',
      viewsHint: '请确认 3D 视角图片，当前视角将作为主图。',
      noFloors: '没有可用的楼层。',
      noContent: '该楼层没有可显示的内容。',
      viewIdle: '尚未截图。',
      recapture: '重新截图',
      capture: '截图',
      reframe: '框选范围',
      reframeCancel: '结束框选',
      reframeHint: '在预览图上拖拽以选择截图范围。',
      zoomIn: '放大',
      zoomOut: '缩小',
      confirm: '确认',
      delete: '删除',
      next: '下一步：3D 视角',
      done: '完成',
      cancel: '取消',
      confirmIncomplete: '请先确认所有楼层平面图和 5 张 3D 报告图片后再完成。',
      mainBadge: '主图',
      captureFailed: '截图获取失败。',
      statusIdle: '未截图',
      statusCapturing: '截图中...',
      statusReady: '待确认',
      statusConfirmed: '已确认',
      statusError: '错误',
      summary: '已确认：楼层 {floors}/{floorTotal} · 3D {views} 张',
      storageTrimmed: '为控制本地存储容量，已裁剪 {count} 张多余的 3D 视角图片。',
      viewNames: {
        main: '主视角',
        current: '当前视角',
        front: '正面',
        back: '背面',
        left: '左侧',
        right: '右侧'
      }
    },
    reportAssetsMissing: {
      title: '报告图片尚未确认',
      message: '当前项目尚未确认平面图和 3D 报告图片。你可以先确认图片，也可以使用系统默认生成的报告资产继续导出。',
      confirmImages: '去确认图片',
      useDefault: '继续使用默认资产导出',
      cancel: '取消'
    },
    reportAssetDefault: {
      generateFailed: '默认报告资产生成失败，请稍后重试。',
      retry: '重试',
      missingFloorPlan: '缺少楼层平面图',
      missing3dView: '缺少 3D 报告图片',
      captureFailed: '截图获取失败'
    },
    shareLink: {
      title: '分享链接',
      generating: '正在生成分享链接...',
      mockNotice: '该链接为演示链接，正式分享将在后端接口接入后启用。',
      copy: '复制链接',
      copied: '已复制',
      copyFailed: '复制失败，请手动复制',
      error: '分享链接生成失败',
      retry: '重试',
      close: '关闭'
    },
    roomAreas: {
      dirtyHint: '房间区域可能已变化，请点击「重新识别房间区域」更新面积。',
      recompute: '重新识别房间区域',
      recomputeSuccess: '房间区域已重新识别',
      recomputeFailed: '房间区域识别失败，已保留原区域',
      recomputeHistory: '重新识别房间区域',
      metricsSummary: '共 {roomCount} 个房间 · 总面积 {totalAreaM2} m² · 卧室 {bedroomCount}'
    },
    exportPdf: {
      success: 'PDF 已开始下载',
      failed: 'PDF 导出失败',
      mockNotice: '当前为 mock 样例 PDF，正式报告将在二阶段后端排版后提供。',
      capturePartial: '部分截图采集失败，已继续导出（不影响编辑）。'
    },
    exportHtml: {
      success: 'HTML 报告已导出并在新标签页预览',
      failed: 'HTML 导出失败',
      mockNotice: '当前为静态 mock HTML，正式托管发布将在二阶段提供。',
      capturePartial: '部分截图采集失败，已继续导出（不影响编辑）。'
    },
    deleteSelected: '删除选中',
    applyToSelection: '应用到选中项',
    moveSelected: '移动选中项',
    moveToFloor: '移动到楼层',
    visible: '可见',
    unchanged: '不变',
    warnings: '警告',
    errors: '错误',
    aiSubmitting: '正在提交 AI 任务...',
    aiProcessing: 'AI 正在生成 · {seconds} 秒 · 第 {attempt} 次查询',
    aiTodo: 'TODO：AI 服务接口暂不启用，参数已保存。',
    featureDeveloping: '功能正在开发中',
    savedLocally: '已保存。',
    saveFailed: '当前修改未保存。',
    draftRestored: '已恢复未保存的编辑草稿。',
    versionRestored: '已恢复本地版本。',
    projectLoaded: '项目已加载。',
    invalidProjectJson: '项目 JSON 无效。',
    importDialogTitle: '导入本地 JSON',
    importAsNewHint: '将导入为新建项目，不影响当前项目。',
    importStructureDecodeFailed: '结构数据无法解析，仅导入建筑部分。',
    importName: '项目名称',
    importBudget: '预算（万日元）',
    importFrontage: '间口（间）',
    importConfirm: '导入为新项目',
    importRequiredFields: '请填写项目名称、预算与间口后再导入。',
    importedAsNewProject: '已作为新项目导入。',
    groups: '分组',
    floors: '楼层',
    opacity: '透明度',
    currentFloor: '当前楼层',
    floorProperties: '楼层属性',
    basicParams: '基础参数',
    layoutOpacity: '显示参数',
    deleteFloor: '删除楼层',
    deleteCurrentFloor: '删除当前楼层',
    deleteFloorConfirmMessage: '删除楼层会将楼层内的所有设计内容都删除，是否继续？',
    guides: '辅助线',
    newGroup: '新建分组',
    addSelected: '添加选中',
    groupName: '分组名称',
    rotate: '旋转',
    duplicate: '复制',
    ungroup: '取消分组',
    deleteAll: '全部删除',
    removeFromGroup: '从分组移除',
    addFloor: '添加楼层',
    addUpperFloor: '新建上层',
    addLowerFloor: '新建下层',
    deleteFloorButton: '删除当前楼层',
    floorInsertPosition: '生成位置',
    floorPositionAbove: '上层（当前楼层之上）',
    floorPositionBelow: '下层（当前楼层之下）',
    floorName: '楼层名称',
    floorCustomNamePlaceholder: '输入楼层名称',
    copyStructure: '复制当前楼层户型结构',
    confirm: '确认',
    duplicateFloor: '复制楼层',
    selectAllFloor: '全选',
    selectAllFloorElements: '全选楼层元素',
    lock: '锁定',
    altitude: '高度',
    floorHeight: '层高',
    slabThickness: '楼板厚度',
    moveUp: '上移',
    moveDown: '下移',
    addSelectedElement: '添加选中元素',
    noVersions: '暂无手动保存版本。',
    restore: '恢复',
    localVersions: '本地版本',
    sceneWidth: '场景宽度 ({unit})',
    sceneHeight: '场景高度 ({unit})',
    name: '名称',
    description: '描述',
    unit: '单位',
    familySize: '家庭人数',
    style: '风格',
    budget: '预算',
    daylightPriority: '优先采光',
    notes: '备注',
    roomRequirements: '房间需求',
    roomRelationships: '房间关系',
    fromRoom: '起始房间',
    toRoom: '目标房间',
    add: '添加',
    aiServiceTodo: 'TODO: AI 服务',
    rooms: {
      living_room: '客厅',
      bedroom: '卧室',
      kitchen: '厨房',
      bathroom: '卫生间',
      dining_room: '餐厅'
    },
    styles: {
      modern: '现代',
      minimal: '极简',
      classic: '经典',
      industrial: '工业'
    },
    budgets: {
      economy: '经济',
      standard: '标准',
      premium: '高端'
    },
    roomStatistics: {
      title: '房间数据统计',
      scope: '范围',
      allFloors: '全部楼层',
      unnamedOrUnrecognized: '未命名/未识别',
      roomType: '房间类型',
      roomCount: '数量',
      totalRooms: '总房间数',
      totalArea: '总面积',
      calculating: '正在计算',
      refreshing: '正在更新',
      stale: '数据可能不是最新',
      recompute: '重新计算房间面积',
       noData: '无可用统计数据'
     },
     aiStructure: {
       entry: 'AI 结构生成',
       modes: {
         label: '显示模式',
         architecture: '建筑',
         structure: '结构'
       },
       overlay: {
         showBuilding: '显示建筑底图',
         hideBuilding: '隐藏建筑底图',
         opacity: '建筑底图透明度'
       },
       plans: {
         label: '结构平面图',
         foundation: '一层楼板结构图',
         'beam-column': '{floor} 屋架结构图',
         'bearing-wall': '{floor} 耐力墙配置图'
       },
       lineModes: {
         label: '绘制模式',
         line: '线',
         fixedWidth: '固定宽度线',
         cappedLine: '端部线'
       },
       messages: {
         readOnly: '当前显示模式为只读。',
         applied: '结构方案已应用。'
       },
       errors: {
         system: '无法获取结构数据，请重试。',
         unavailable: '结构数据不可用，请重新生成。',
         readOnly: '当前显示模式为只读。'
       },
       properties: {
         title: '结构对象属性',
         empty: '选择结构对象后，这里显示只读属性。',
         layer: '楼层',
         type: '类型',
         role: '角色',
         section: '截面',
         elevation: '标高',
         hostWall: '宿主墙',
         wallSpecification: '墙规格'
       }
     },
     mechanicsCheck: {
       historyUnlinked: "历史校验未记录结构关联，无法确认适用版本。请重新执行力学校验。",
       runningPrevious: "新一轮校验中，当前展示上次成功完成的结果。",
       latestFailedPrevious: "最新一次校验失败，当前展示上次成功完成的结果。",
       recoveryFailed: "云端校验结果加载失败，请刷新重试。",
       recoveryUnlinked: "此结构缺少可验证的任务关联，请重新生成结构后执行校验。",
       showFailures: '查看不合格构件',
       hideFailures: '取消查看',
       detailTitle: '构件不合格详情',
       detailEmpty: '校验结果未提供详细说明。',
       entry: '结构力学校验',
       requiresStructure: '请先完成 AI 结构生成。',
       started: '结构力学校验已开始。',
       completed: '结构力学校验已完成。',
       failed: '结构力学校验失败，请重试。',
       resultTitle: '力学校验结果',
       resultLoading: '正在进行结构力学校验…',
       resultPreparing: '正在读取力学校验结果…',
       resultPreparingDescription: '校验计算已完成，正在读取结果文件。',
       resultEmpty: '尚未执行结构力学校验。',
       statusDescription: '正在等待校验结果，当前结构仍在显示。'
     }
   },
  designEvaluation: {
    entry: '设计评价',
    dialogTitle: '设计评价',
    planPreviewLabel: '平面图',
    previewLoading: '正在生成平面图',
    previewFailed: '该楼层平面图生成失败',
    retryPreview: '重试',
    designNotReady: '请先完成 AI 设计',
    backendUnavailable: '评价功能暂不可用',
    scoreLabel: '评分',
    scoreRequired: '请选择 1–10 分',
    scoreAriaHint: '评分 1 至 10',
    commentLabel: '评价意见',
    commentPlaceholder: '请输入评价',
    commentCounter: '已输入 {count} / 1000',
    submissionNotice: '平面图仅供确认；提交内容仅包含设计ID、评分和评语',
    submit: '提交评价',
    cancel: '取消',
    submitting: '提交中',
    successMsg: '评价已记录',
    errorScore: '评分无效，请选择 1–10 整数',
    errorCommentTooLong: '评价文本超过 1000 字符',
    errorForbidden: '当前账号无评价权限',
    errorNotFound: '设计不存在或不可访问',
    errorNotReady: 'AI 设计尚未完成',
    errorRateLimited: '提交过于频繁，请稍后重试',
    errorInternal: '提交失败，请稍后重试',
    errorGeneric: '提交失败'
  },
  floorplan: {
    categories: {
      lines: '墙体',
      holes: '门窗',
      structure: '结构',
      furnishings: '家具软装',
      items: '物件',
      areas: '区域'
    },
    elements: {
      wall: '墙',
      "door": "单扇平开门",
      "door-double": "双扇平开门",
      "door-parent-child": "子母门",
      "sliding-door": "双扇推拉门",
      "door-pocket": "墙内单拉门",
      "door-surface-sliding": "墙外单拉门",
      "door-folding": "折叠门",
      "window": "推拉窗",
      "window-fixed": "固定窗",
      "window-side-hung": "侧开窗",
      "window-casement": "竖向滑撑外开窗",
      "window-awning": "横向外开窗",
      split: '洞口',
      sofa: '沙发',
      bed: '床',
      chair: '椅子',
      bench: '长凳',
      'dining-table': '餐桌',
      'round-table': '圆桌',
      'low-table': '矮桌',
      desk: '书桌',
      'side-table': '边几',
      console: '玄关台',
      shelf: '置物架',
      cabinet: '柜子',
      'clothes-rack': '衣架',
      'tv-board': '电视柜',
      refrigerator: '冰箱',
      kitchen: '厨房台面',
      toilet: '马桶',
      bathtub: '浴缸',
      washbasin: '洗面台',
      'washing-machine': '洗衣机',
      'shoe-cabinet': '鞋柜',
      stair: '楼梯',
      'sofa-B': '沙发 B',
      'chair-A': '椅子 A',
      'chair-B': '椅子 B',
      column: '柱子',
      beam: '梁',
      'floor-opening': '楼板洞口',
      'ceiling-opening': '上部挑空',
      'ceiling-drop': '下沉吊顶',
      'column-square': '方柱',
      'independent-column': '独立柱',
      'fridge-A': '冰箱 A',
      'simple-stair': '直楼梯',
      'stair-l': 'L形楼梯',
      'stair-u': 'U形楼梯',
      'stair-c': '三跑楼梯',
      'tv-board-A': '电视柜 A',
      'tv-board-B': '电视柜 B',
      area: '房间区域'
    },
    attributes: {
      name: '名称',
      visible: '可见',
      x: 'X',
      y: 'Y',
      rotation: '角度',
      offset: '位置',
      catalogItemId: 'Catalog 项',
      modelId: '模型 ID',
      textureId: '贴图 ID',
      materialId: '材质 ID',
      displayName: '显示名称',
      computedAreaM2: '面积 (m²)',
      computedAreaTsubo: '面积 (坪)'
    },
    properties: {
      type: "形式",
      hinge: "铰链／移门侧",
      swing: "开启方向",
      registeredSize: "登记尺寸",
      foldingPanels: "门扇数",
      handleStyle: "把手",
      finish: '饰面',
      beamDepth: '梁高',
      dropDepth: '下沉高度',
      openingWidth: "门洞宽",
      storageSide: "收纳方向",
      mountSide: "安装侧",
      pocketSlotSide: "收纳槽侧",

      size: '尺寸',
      basicParams: '基础参数',
      dimensionParams: '尺寸',
      roomName: '房间名',
      sizeVariant: '尺寸规格',
      selectedMaterial: '当前',
      searchMaterial: '按名称筛选',
      noMaterialMatch: '没有符合的材质',
      manufacturer: '品牌',
      width: '宽度',
      depth: '深度',
      height: '高度',
      length: '长度',
      thickness: '厚度',
      floorDistance: '离楼板距离',
      topHeight: '顶端高度',
      lighting: '照明',
      lightOnEvening: '傍晚以后点亮',
      floorElevation: '地面高差',
      elevation: '离地高度',
      color: '颜色',
      material: '材质',
      texture: '纹理',
      texturePreview: '纹理预览',
      rotation: '角度',
      offset: '位置',
      open: '开启',
      flip_orizzontal: '反转',
      position: '位置'
    },
    beamFinishes: {
      wood: '木纹（装饰梁）',
      wallpaper: '墙纸（包梁）'
    },
    handleStyles: {
      lever: "执手",
      knob: "球形把手",
      pull: "拉手",
      bar: "长拉手",
      recessed: "凹槽拉手",
      none: "无"
    },
    fittingOptions: {
      panelCount: '{n} 扇',
      left: "左",
      right: "右",
      in: "向内",
      out: "向外",
      storageLeft: "向左收纳",
      storageRight: "向右收纳",
      mountIn: "内侧",
      mountOut: "外侧",
      slotIn: "内侧",
      slotOut: "外侧"
    },
    textures: {
      plain: '纯色',
      default: '未设置',
      bricks: '砖墙',
      painted: '涂料',
      wood: '木地板',
      tile: '瓷砖',
      tatami: '榻榻米',
      concrete: '混凝土',
      none: '无'
    },
    materials: {
      fabric: '织物',
      wood: '木材',
      metal: '金属',
      glass: '玻璃',
      plastic: '塑料'
    }
  },
  errors: {
    sessionExpired: '登录状态已过期，请重新登录',
    requestFailed: '请求失败',
    aiDesignNetworkError: '网络错误，请检查连接',
    aiDesignTimeout: '设计超时，请稍后重试',
    aiDesignServiceError: '服务暂时不可用',
    aiDesignValidationError: '输入验证失败',
    aiDesignPartitionFailed: '无法根据当前外轮廓生成初始房间，请调整轮廓后重试',
    aiDesignOutlineShrunk: 'AI 返回的建筑范围小于原轮廓，已放弃本次结果',
    aiDesignParseError: '结果格式错误',
    aiDesign: {
      VALIDATION_ERROR: '输入数据验证失败',
      NETWORK_ERROR: '网络连接失败',
      TIMEOUT: '服务执行超时',
      REMOTE_SERVICE_ERROR: 'AI 服务返回失败状态',
      PARSE_ERROR: '下载包或 JSON 无法解析',
      PARTITION_FAILED: '当前墙图无法形成完整 AI 输入区域',
      OUTLINE_SHRUNK: '建筑范围发生变化',
      AI_RESULT_INVALID: 'AI 返回无效结构',
      AI_RESULT_STATS_MISMATCH: '后端统计与实际门窗不一致',
      AI_ELEMENT_GEOMETRY_CHANGED: '门窗阶段越权修改了墙或房间',
      AI_SOURCE_SCENE_CHANGED: '户型已变更，候选方案已过期',
      APPLY_FAILED: '应用 AI 方案失败',
      UNKNOWN: '未知错误'
    }
  },
  reportStudio: {
    entry: '图片制作',
    back: '返回编辑器',
    save: '保存',
    saveSuccess: '报告素材已保存',
    saveFailed: '报告素材保存失败，请稍后重试',
    saveStatusUnsaved: '未保存',
    saveStatusSaved: '已保存',
    canvasPlaceholder: '{type} 待实现',
    settingsPlaceholder: '设置栏（待实现）',
    assetRailPlaceholder: '素材栏（待实现）',
    types: {
      layout: '配置图',
      floorPlan: '平面布置图',
      render: '3D 渲染图',
      elevation: '立面图'
    },
    rail: {
      title: '已保存素材',
      empty: '当前类型暂无已保存素材',
      delete: '删除',
      confirmForReport: '确认用于PDF/HTML报告',
      confirmedForReport: '已确认用于PDF/HTML',
      statusPreview: '预览未确认',
      statusMissing: '缺失/待确认',
      slots: {
        layout: '配置图',
        floorPlan: '楼层 {layer}',
        renderMain: '主视角',
        renderSubTop: '辅图（上）',
        renderSubBottom: '辅图（下）',
        elevationFront: '正面',
        elevationBack: '背面',
        elevationLeft: '左侧',
        elevationRight: '右侧'
      }
    },
    render: {
      renderType: '渲染类型',
      renderTypeScreenshot: '当前截图',
      aiRender: 'AI 渲染',
      aiRenderPending: '接口待接入',
      cameraPresets: '视角预设',
      presets: {
        'oblique-front': '斜前方',
        aerial: '鸟瞰'
      },
      renderStyle: '渲染风格',
      renderStylePlaceholder: '即将支持',
      aspectRatio: '画面比例',
      aspectRatioPlaceholder: '即将支持',
      saveCurrentView: '保存当前视角',
      saveAsMain: '保存为主图',
      saveAsSubTop: '保存为右上图',
      saveAsSubBottom: '保存为右下图',
      resetCamera: '重置视角',
      captureFailed: '3D 截图失败'
    },
    elevation: {
      direction: '方向',
      directions: {
        front: '正面',
        back: '背面',
        left: '左侧',
        right: '右侧'
      },
      layoutMode: '排版模式',
      layoutModeSingle: '单张制作',
      layoutModeOverview: '四图总览',
      saveCurrentView: '保存正交视角',
      saveDirection: '保存{direction}',
      unsaved: '未保存',
      backToOverview: '返回四图总览',
      resetCamera: '重置视角',
      captureFailed: '3D 截图失败',
      generateSingleViewPreview: '生成单个视角预览'
    },
    confirm: {
      replaceTitle: '替换已确认图片',
      replaceMessage: '该素材已确认用于 PDF/HTML 报告，是否用新图片替换？',
      deleteTitle: '删除报告素材',
      deleteMessage: '删除后报告将缺失该素材，是否继续？',
      noPreview: '请先在左侧生成或选择图片',
      confirmButton: '确认'
    },
    capture: {
      deprecatedGuard: '此对话框已退出生产导出路径，请使用报告素材制作页确认后再导出。'
    },
    layout: {
      imageSource: '图片来源',
      upload: '上传图片',
      pickExisting: '从已有图选择',
      pickEmpty: '暂无可选图片',
      fitMode: '适配方式',
      fitWidth: '适应宽度',
      fitHeight: '适应高度',
      fitPage: '适应页面',
      saveLayout: '保存配置图',
      noImageSelected: '请上传或选择一张图片',
      canvasEmpty: '白页预览（未选择图片）',
      zoomIn: '放大',
      zoomOut: '缩小',
      uploadFailed: '图片读取失败',
      uploadInvalidType: '请选择图片文件'
    },
    floorPlan: {
      floorSwitch: '楼层切换',
      visibility: '显隐开关',
      showTotalDimensions: '四周总尺寸',
      showSegmentDimensions: '顶底分段尺寸',
      showRoomNames: '房间名称',
      showRoomAreas: '房间面积',
      showFurniture: '家具',
      showHoles: '门窗',
      dimensionActions: '尺寸操作',
      autoGenerate: '自动生成',
      addManual: '新增',
      cancelManualAdd: '取消新增',
      deleteSelected: '删除选中',
      hideSelected: '隐藏选中',
      regenerateAll: '重新生成全部',
      resetOffsets: '重置 offset',
      roomLabelActions: '房间标签',
      toggleRoomLabels: '标签显隐',
      resetRoomLabelPositions: '重置位置',
      saveCurrentFloor: '保存当前楼层为报告素材',
      captureFailed: '平面图截图失败',
      noChainSelected: '请先选中尺寸链',
      manualAddHint: '在画布上依次点击两个点',
      manualAddInvalid: '当前仅支持水平/竖直尺寸',
      noDimensionBounds: '当前楼层没有可生成尺寸的轮廓'
    }
  },
  reportExportConfirm: {
    title: {
      pdf: 'PDF 报告导出确认',
      html: 'HTML 报告导出确认'
    },
    generatePdf: '生成 PDF 报告',
    generateHtml: '生成 HTML 报告',
    optionalBadge: '可选',
    missingHint: '尚有 {count} 项必填素材缺失或待确认，请补全后再生成。',
    optionalMissingHint: '配置图为可选项，缺失不影响报告生成。',
    openStudioHint: '点击前往制作页确认',
    statusConfirmed: '已确认',
    statusPreview: '待确认',
    statusMissing: '缺失/待确认'
  },
  // P06: 异步 AI 设计 UI 文案（供 P01–P05/P07 对齐；勿与 errors.aiDesign 混淆）
  aiDesign: {
    fields: {
      productType: 'ProductType（项目名）',
      totalArea: 'TotalArea（坪）',
      layers: 'Layers（楼层）',
      widthKen: 'WidthKen（间口）',
      unitPrice: '坪单价',
      unitPriceValue: '{count} 万日元/坪',
      totalAreaValue: '{count} 坪',
      budget: '预算',
      frontage: '间口',
      projectName: '项目名称',
      algorithm: '算法'
    },
    algorithms: {
      floorplan_diffusion: '扩散模型',
      floorplan_gpt_image_2: 'VLM',
      floorplan_gpt6: 'LLM Agent',
      building_element_diffusion: '门窗 Diffusion',
      building_element_rule: '门窗规则'
    },
    status: {
      queued: '排队中',
      generating: '正在生成',
      completed: '已完成',
      failed: '生成失败',
      waitedTime: '已等待 {seconds} 秒',
      canLeavePage: '可以离开本页面'
    },
    actions: {
      abandonTask: '放弃任务',
      abandonConfirm: '确定放弃任务「{name}」吗？放弃后结果将不再提示或应用。',
      viewNewPlan: '查看新方案',
      confirmReplace: '确认替换',
      retrySameParams: '按原参数重试'
    },
    waiting: {
      editLocked: '生成期间编辑已锁定。任务会在后台继续，您可以离开本页面稍后再来查看。',
    },
    messages: {
      floorplanChanged: '当前户型已变化',
      regenerateWindows: '请重新生成门窗',
      busy: '后台繁忙，请稍后再试。',
      taskRecordCorrupted: '任务记录损坏',
      resultInvalid: '结果无效'
    },
    projectCard: {
      generating: '生成中',
      completed: '完成',
      failed: '失败'
    },
    validation: {
      budget: '预算须为 500–3500 的整数（万日元）',
      input: '输入无效',
      projectName: '请输入项目名称',
      frontage: '间口须为 2–5 间（步长 0.5）',
      layers: '楼层须为 1–3',
      algorithm: '所选算法与当前设计类型不匹配'
    }
  },
  drawingVectorize: {
    editor: {
      loadFailed: '无法加载标定后的图纸，请稍后重试。',
      rescale: '比例尺',
      autosaveOn: '自动保存',
      autosaveSaving: '保存中…',
      autosaveSaved: '已保存',
      autosaveFailed: '保存失败',
      furnitureArriving: '正在放置家具…',
      furnitureFailed: '家具识别失败。房间可以照常编辑',
      reupload: '重新生成',
      reuploadConfirm: '返回上传页面。'
    },
    rescale: {
      title: '修改比例尺',
      gridTitle: '小网格',
      gridHint: '墙体对齐所用的网格尺寸。',
      warning: '更改比例尺后，编辑器中的修改会被还原。',
      apply: '按此比例尺重新生成',
      confirm: '按此比例尺重新生成吗？',
      done: '已修改比例尺'
    },
    upload: {
      title: '从图纸导入',
      handDrawnTitle: '上传手绘平面图',
      subtitle: '上传平面图，自动识别墙体、门窗与房间。图纸上有尺寸时会自动设定比例尺；读不到时点选一条已知长度的墙，输入真实尺寸即可确定比例尺。',
      dropTitle: '图纸上传',
      dropMain: '请将平面图拖放到此处',
      dropSub: '直接拖入图片或文档，或点击此区域选择文件',
      page: 'PDF 页码',
      pdfSelectTitle: '请选择要识别的页面',
      pdfLoading: '正在加载 PDF 页面…',
      pdfFailed: '无法预览该 PDF，请改用页码指定。',
      pdfPageLabel: '第 {page} 页',
      pdfPageCount: '共 {count} 页',
      pdfTooManyPages: '仅显示前 {max} 页。',
      accepted: '支持 PNG / JPEG / TIFF / PDF，最大 5MB',
      tooLarge: '文件超过 5MB',
      start: '开始识别',
      cancel: '取消',
      stopWaiting: '停止等待',
      retry: '重试',
      detail: '详细信息',
      projectName: '项目名称',
      apply: '进入编辑器',
      reupload: '重新上传图纸',
      backToEditor: '返回编辑器',
      sourceTitle: '上传的图纸',
      sourceOpen: '点击查看大图',
      sourceClose: '关闭',
      removeFile: '删除已上传的图纸',
      regionHint: '拖动边框可选择识别范围。',
      regionReset: '恢复为整页',
      reading: '正在读取图纸…',
      restoring: '正在载入上次的图纸…',
      restoreFailed: '无法载入上次的图纸，请重新上传。',
      sourceNoPreview: 'PDF 无法在此直接预览。'
    },
    progress: {
      uploading: '正在上传图纸',
      queued: '已排队，等待识别',
      recognizing: '正在识别',
      backgroundNotice: '关闭后识别仍会继续。'
    },
    calibrate: {
      title: '比例尺标定',
      badgeCalibrated: '已标定',
      badgeUncalibrated: '未标定',
      assumedNotice: '请输入正确的尺寸',
      pickPrompt: '在图上点选一条已知长度的墙。',
      wholeWall: '轴线尺寸（芯到芯）',
      wholeWallUnavailable: '这条线反查不到原始墙，只能按单段测量。',
      currentLength: '当前长度',
      currentLengthValue: '约 {mm} mm（{px} px）',
      inputPlaceholder: '真实长度，单位毫米',
      submit: '标定',
      submitting: '计算中…',
      result: '{mmPerPx} mm/px ／ 参考：{reference}',
      badgeAuto: '自动设定',
      badgeSuggested: '待确认',
      autoTitle: '已根据图纸上的尺寸自动设定比例尺。',
      suggestedTitle: '已根据图纸上的尺寸推定比例尺，请确认后再确定。',
      reasons: {
        single_orientation: '只读到了横向或纵向其中一个方向的尺寸。',
        orientation_disagree: '横向与纵向尺寸算出的比例尺不一致。',
        no_long_baseline: '没有读到贯穿整栋建筑的长尺寸。',
        few_inliers: '相互吻合的尺寸条数不足。',
        low_agreement: '读取到的尺寸之间差异较大。'
      },
      extentValue: '建筑外形：约 {width} m × {height} m',
      acceptEstimate: '按此比例尺确定',
      pickPromptOverride: '如果不对，请在图上点选一条已知长度的墙并输入长度。',
      overridden: '已从按图纸尺寸自动设定的比例尺（{mmPerPx} mm/px）改为手动标定。',
      revertToEstimate: '恢复自动设定',
      referenceDimensions: '图纸尺寸'
    },
    quality: {
      title: '建议复核',
      adjustment: '识别调整「{action}」：{count} 处',
      // 楼梯识别的调整记录。没有对应文案的动作码仍原样显示（见 WizardImportDrawingView）。
      actions: {
        area_relabelled_staircase: '房间里画有楼梯，已改为楼梯间',
        stair_synthesized_from_area: '在楼梯间内自动放置楼梯（未识别到楼梯本体）',
        stair_form_inferred: '楼梯形式按房间形状推断',
        stair_direction_inferred: '楼梯上行方向为推断',
        stair_facing_conflicts_footprint: '上行方向与占地矛盾，已调整朝向',
        stair_form_conflicts_footprint: '楼梯形式与占地矛盾，改按房间形状推断',
        stair_area_not_rectangular: '楼梯间不是矩形',
        stair_footprint_fallback_to_preset: '房间尺寸不合适，改用标准尺寸楼梯',
        stair_footprint_from_detection: '房间缺一角，楼梯占地改取识别框（楼梯架在楼梯下收纳上方）',
        stair_footprint_from_room_label: '识别框太小，楼梯占地改取房间标注框',
        stair_clamped_to_min_footprint: '房间太小，改用最小尺寸楼梯',
        stair_overflows_area: '楼梯超出了房间范围',
        stair_without_area: '楼梯不在任何房间内',
        stair_dropped_at_placement: '无法放置的楼梯',
        staircase_area_without_stair: '楼梯间过大或过小，未放置楼梯',
        staircase_label_ignored: '仅有 UP / DN 标注的大房间不按楼梯间处理',
        stair_opening_added: '在楼梯口那面墙上开了洞口（按楼梯朝向推定）',
        stair_opening_skipped_exterior: '楼梯口对着外墙，未开洞口（请确认楼梯朝向）',
        stair_opening_skipped_room: '楼梯口对着卫浴、收纳或卧室，未开洞口（请确认楼梯朝向）',
        stair_opening_skipped_narrow: '楼梯口那面墙太短，开不出洞口',
        stair_orientation_from_start: '楼梯朝向按行走线起点（UP / DN 的起点）校正',
        stair_direction_from_neighbour: '楼梯朝向按楼梯口外面的房间推定',
        furniture_outside_building_dropped: '已去掉远离建筑的家具（多为从同一页的效果图中误识别）',
        floor_level_from_drawing: '根据图纸上的楼面标高（1FL-200、+300 等）设置了地板高差',
        floor_level_assumed_from_name: '跃层（スキップフロア）、小上がり的地板高度按默认值设置（图纸上没有标高度，请在编辑器中确认）',
        floor_boundaries_split_rooms: '按地面高差、扶手线（不是墙）划分了房间',
        stair_room_carved: '楼梯与相邻房间连成了一片，已把楼梯切成单独的房间',
        column_dropped: '未作为独立柱放置的候选（尺寸不符、在墙内或家具内）'
      },
      unmatchedRooms: '未能匹配到面的房间：{names}',
      reviewRequired: '整体建议人工复核。',
      adviceOnly: '可在编辑器中修改。'
    },
    errors: {
      DRAWING_VECTORIZE_BUSY: '识别服务忙，约 {seconds} 秒后重试。',
      DRAWING_VECTORIZE_FAILED: '识别失败，请稍后重试。',
      DRAWING_INPUT_UNSUPPORTED: '文件格式不支持。请选择 PNG / JPEG / TIFF / PDF，且不超过 5MB。',
      DRAWING_CALIBRATION_INVALID: '按这个长度无法标定。换一条墙或核对一下实际尺寸。',
      DRAWING_SCENE_REJECTED: '识别结果无法载入编辑器。',
      TIMEOUT: '等待超时，请重试。',
      NETWORK_ERROR: '网络不可达。',
      REMOTE_SERVICE_ERROR: '服务返回错误。',
      VALIDATION_ERROR: '请检查输入内容。',
      STORAGE_WRITE_FAILED: '保存失败。',
      NAME_REQUIRED: '请填写项目名称。',
      NOT_CALIBRATED: '比例尺尚未标定，请先输入真实长度。',
      IMPORT_FAILED: '创建项目失败。',
      DRAWING_JOB_SUBMIT_FAILED: '提交识别任务失败，请重试。',
      DRAWING_JOB_NOT_FOUND: '找不到这个识别任务，请重新发起。',
      DRAWING_JOB_FAILED: '识别任务执行失败，请重试。',
      DRAWING_JOB_TIMEOUT: '等待识别超时。任务可能仍在后台运行，请稍后重试。',
      DRAWING_RESULT_NOT_READY: '识别结果尚未就绪，请稍候。',
      UNKNOWN: '发生未知错误。'
    }
  },
  el: elementLocale.el
}
